<!--
 * @Author: mazhigang
 * @Date: 2023-09-02 22:16:19
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-25 20:44:57
-->
<template>
  <div>
    <div class="box">
      <div class="content">
        <div class="imgItem" style="margin-left: 25px;">
          <img src="../../static/douyin.png" alt="" />
          <div>
            <div style="margin-bottom: 15px;font-size: 16px;">
              抖音扫码关注官方抖音号
            </div>
            <div style="font-size: 14px">咖德</div>
          </div>
        </div>
        <div class="imgItem" style="margin-left: 25px;">
          <img src="../../static/weixin.png" alt="" />
          <div>
            <div style="margin-bottom: 15px;font-size: 16px;">
              扫码关注微信公众号
            </div>
            <div style="font-size: 14px">咖德保安</div>
          </div>
        </div>
        <div class="logo">
          <img src="/static/bigLogo.png" alt="" />
          <div style=" margin-bottom: 10px;">企业地址</div>
          <div style="font-size: 12px;color: #B4B4B4;">
            北京市⼤兴区经济技术开发区景园北街2号61幢21层
          </div>
          <div class="infoItem" style="margin-top: 20px;">
            <div class="itemInfo" style="margin-top: 10px;">
              <a
                style="color: #fff;"
                target="_blank"
                href="https://work.weixin.qq.com/kfid/kfce3086cb4030f1cb8"
                >客服咨询</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="solid"></div>
      <div>
        <div class="bottomText">
          <div style="margin-top: 10px; font-size: 12px;color: #999999 ;">
            <a
              target="_blank"
              href="https://beian.miit.gov.cn/"
              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color: #999999;display: flex;align-items: center;justify-content: center;"
            >
              <div>@2025 北京咖德蔚来科技有限公司&nbsp;|&nbsp;</div>
              京ICP备2023024151号-1
              <div style="margin-left: 10px;display: flex;align-items: center;">
                <img src="/static/gongan.png" alt="" />京公网安备号
                11030102011656 |&nbsp;
              </div>
              <div>
                增值电信经营许可证 京B2-20243546
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},

  methods: {
    goPage(type) {
      if (type === 1) {
        this.$router.push("/plan");
      } else if (type === 2) {
        this.$router.push("/cooperate");
      } else if (type === 3) {
        this.$router.push("/about");
      }
    }
  }
};
</script>
<style scoped>
.box {
  width: 100%;
  padding: 39px 0 0;
  box-sizing: border-box;
  background: #14162d;
  background-size: 100% 100%;
}
.content {
  width: 1120px;
  margin: 0 auto 0;
  display: flex;
  justify-content: space-between;
}
.logo {
  font-size: 12px;
  color: #fff;
  line-height: 18px;
}
.logo img {
  margin-bottom: 12px;
  width: 92px;
  height: 42px;
}
.bottomInfo {
  display: flex;
}
.infoItem {
  margin-right: 50px;
  font-weight: 400;
  color: #fff;
  line-height: 12px;
}
.itemTitle {
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  line-height: 14px;
  margin-bottom: 10px;
}
.itemInfo {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  cursor: pointer;
}
.itemInfo img {
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
.imgs {
  display: flex;
}
.imgItem {
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  line-height: 12px;
  display: flex;
  align-items: center;
}
.imgItem img {
  width: 119px;
  height: 119px;
  margin-right: 16px;
}
.solid {
  width: 100%;
  background: #475061;
  height: 1px;
  margin-top: 30px;
}
.bottomText {
  width: 100%;
  text-align: center;
  font-size: 8px;
  font-weight: 400;
  color: #fff;
  line-height: 13px;
  padding-bottom: 10px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/pagebottom.vue